export enum EnumMovModelo {
    ORCAMENTO = 10,
    SAT = 40,
    NFE = 55,
    NFCE = 65,
    ENTRADA = 80,
    TROCA = 90
}